import React, {Component} from 'react';
import topBar from '../modules/topBar';
import navbar from '../modules/navbar';
import creatConsultations from '../modules/creatConsultations';

class CreatConsultationsPageComponent extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {
  }

  render() {
  	return (
	    <div id="page-creat-consultations">
        <topBar.container/>
        <div className="bottom-container">
          <navbar.container/>
          <div className="main-section">
            <creatConsultations.container />
          </div>
        </div>
	    </div>
	  )
  }
}

export default CreatConsultationsPageComponent;
